import DragHandleIcon from '@mui/icons-material/DragHandle'
import ShareIcon from '@mui/icons-material/Share'

export const refineConfig = {
  options: {
    syncWithLocation: true,
    warnWhenUnsavedChanges: true,
    useNewQueryKeys: true,
    projectId: 'Pi6n6i-Wca6QU-LVqvwC',
  },
  resources: [
    {
      name: 'request',
      list: '/request',
      show: '/request/:id',
      meta: {
        icon: <DragHandleIcon />,
      },
    },
    {
      name: 'share',
      list: '/share',
      meta: {
        label: 'Shared Requests',
        icon: <ShareIcon />,
      },
    },
  ],
}
